/**
 * Session gates for saved-zone restore vs user-initiated playback.
 * Saved-zone restoration may run only before the user starts playback.
 */

import { useMaestroStore } from '../store/maestroStore';
import { TransportCommand } from './TransportCommand';
import { QueueController } from './QueueController';

let userPlaybackStarted = false;

export function markUserPlaybackStarted(): void {
  userPlaybackStarted = true;
}

export function hasUserPlaybackStarted(): boolean {
  return userPlaybackStarted;
}

/** True when saved-zone restore must not change the active renderer. */
export function canRestoreSavedZone(): boolean {
  if (userPlaybackStarted) return false;

  const store = useMaestroStore.getState();
  const ps = store.playbackState;
  if (ps === 'playing' || ps === 'loading') return false;
  if (TransportCommand.isPlayUriRecent(8000)) return false;
  if (QueueController.isPlaybackInitiating) return false;

  return true;
}
